import { render, staticRenderFns } from "./FormSaveSearch.vue?vue&type=template&id=ba89607c"
import script from "./FormSaveSearch.vue?vue&type=script&lang=js"
export * from "./FormSaveSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports